export default {"src":"/_next/static/media/swiss-made-software.2f7fd229.svg","height":28,"width":97,"blurWidth":0,"blurHeight":0};